import { render, staticRenderFns } from "./BaseCarousel.vue?vue&type=template&id=1c6d1de4&scoped=true&v-if=itemsCount&"
import script from "./BaseCarousel.vue?vue&type=script&lang=js&"
export * from "./BaseCarousel.vue?vue&type=script&lang=js&"
import style0 from "./BaseCarousel.vue?vue&type=style&index=0&id=1c6d1de4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6d1de4",
  null
  
)

export default component.exports